/**
 * Async component import.
 *
 * @param promise - The promise to import the component from.
 * @returns The component.
 */
export function asyncComponent(fcn) {
    return () => fcn().then(m => m.default);
}
//# sourceMappingURL=asyncComponent.js.map